export default __webpack_public_path__ + "static/media/Minicard_Js.ac2fbf1e.svg";